import createReducer from 'utils/createReducer';
import { SET_USER_DETAIL } from 'state/actionTypes';
import { combineReducers } from 'redux';

const initialState = {
  data: {},
};

const userDetail = createReducer(initialState, {
  [SET_USER_DETAIL]: (state, { payload }) => ({ ...state, ...payload }),
});

export default combineReducers({
  userDetail,
});
